import { api } from './client.ts';
import type { components } from './schema.gen.ts';
import { failedOnTheServer } from './serverFailure.ts';

export const readStreamRefusal = async (): Promise<string> => {
  const probe = new AbortController();
  const { error } = await api.GET('/game/notifications', { parseAs: 'stream', signal: probe.signal });
  probe.abort();
  return error && !failedOnTheServer(error) ? error.message : '';
};

export type NotificationTopic = components['schemas']['NotificationTopic'];
export type GameChangedNotification = components['schemas']['GameChangedNotification'];
export type TimeNotification = components['schemas']['TimeNotification'];
export type TraceNotification = components['schemas']['TraceNotification'];

export type StreamNotification = GameChangedNotification | TimeNotification | TraceNotification;

export type NotificationFrame<N extends StreamNotification> = MessageEvent<`${N['data']}`>;
